import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const steps = [
  {
    number: '1',
    icon: 'ri-global-line',
    title: 'Entra a peregrinacioninterior.com',
    description: 'Visita nuestro sitio web para comenzar',
  },
  {
    number: '2',
    icon: 'ri-book-2-line',
    title: 'Compra el Cuaderno de La Magdalena (opcional)',
    description: 'Disponible en Amazon o versión digital',
  },
  {
    number: '3',
    icon: 'ri-bank-card-line',
    title: 'Realiza el pago del curso',
    description: 'Por PayPal o Zelle',
  },
  {
    number: '4',
    icon: 'ri-whatsapp-line',
    title: 'Confirma tu inscripción por WhatsApp',
    description: 'Usa el link de confirmación',
  },
  {
    number: '5',
    icon: 'ri-group-line',
    title: 'Te agregamos al grupo de estudio',
    description: 'Recibes el material diario',
  },
];

export default function Steps() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="relative py-32 px-6 bg-dark-900">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-2xl text-dark-900"></i>
            </div>
            <h2 className="font-serif text-5xl md:text-6xl text-gold-400">
              Inscripción en 5 pasos
            </h2>
          </div>
          <p className="font-sans text-xl text-warm-200 max-w-3xl mx-auto">
            Sigue estos sencillos pasos para comenzar tu peregrinación interior
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-16">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="relative"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-[60%] w-full h-0.5 bg-gradient-to-r from-gold-500/50 to-gold-500/20 z-0"></div>
              )}

              <div className="relative bg-dark-800 border border-gold-500/20 rounded-lg p-6 hover:border-gold-500/50 transition-all duration-300 h-full">
                {/* Number badge */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center shadow-lg z-10">
                  <span className="font-serif text-2xl font-bold text-dark-900">
                    {step.number}
                  </span>
                </div>

                {/* Icon */}
                <div className="flex items-center justify-center w-16 h-16 bg-gold-500/10 rounded-full mb-6 mt-4">
                  <i className={`${step.icon} text-4xl text-gold-400`}></i>
                </div>

                {/* Content */}
                <h3 className="font-serif text-xl text-warm-100 mb-3 min-h-[60px]">
                  {step.title}
                </h3>

                <p className="font-sans text-warm-200 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Important note */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="bg-gold-500/10 border border-gold-500/30 rounded-lg p-8 max-w-4xl mx-auto"
        >
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-3xl text-gold-400 flex-shrink-0"></i>
            <p className="font-sans text-lg text-warm-100 leading-relaxed">
              <strong className="text-gold-400">Nota importante:</strong> Si no compras el cuaderno físico, recibirás la versión digital en PDF por email.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
